if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.submitButton = this.querySelector('[type="submit"]');
        this.querySelectorAll(".bundle-product-selector select").forEach(
          (select) => {
            select.addEventListener("change", this.priceChange.bind(this));
          },
        );
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          },
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading__spinner",
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`,
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading__spinner",
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`,
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      priceChange() {
        const totals = Array.from(this.querySelectorAll("select")).reduce(
          (acc, select) => {
            const option = select.selectedOptions
              ? select.selectedOptions[0]
              : undefined;
            if (!option || option.dataset.priceSet === undefined) {
              return acc;
            }

            const priceValue = this.parsePrice(option.dataset.priceSet);
            const compareRaw = option.dataset.comparePriceSet
              ? this.parsePrice(option.dataset.comparePriceSet)
              : priceValue;
            const compareValue = compareRaw > 0 ? compareRaw : priceValue;
            const multiplier = this.parsePositiveInt(
              select.dataset.amount || option.dataset.amount,
            );

            return {
              price: acc.price + priceValue * multiplier,
              compare: acc.compare + compareValue * multiplier,
            };
          },
          { price: 0, compare: 0 },
        );

        const priceElement = this.querySelector(".price");
        if (!priceElement) return;

        const basePrice = parseInt(priceElement.dataset.price || "0", 10);
        const baseCompare = parseInt(
          priceElement.dataset.comparePrice || "0",
          10,
        );
        const moneyFormat = this.getAttribute("data-money-format");

        if (priceElement.classList.contains("price--on-sale")) {
          const saleSpan = priceElement.querySelector(
            ".price__sale .price-item--sale span:first-child",
          );
          const compareSpan = priceElement.querySelector(
            ".price__sale s.price-item--regular",
          );
          const badge = priceElement.querySelector(".badge--saving");

          const saleTotal = basePrice + totals.price;
          const compareTotal = baseCompare + totals.compare;

          if (saleSpan) {
            saleSpan.innerHTML = this.formatMoney(saleTotal, moneyFormat);
          }

          if (compareSpan) {
            compareSpan.innerHTML = this.formatMoney(compareTotal, moneyFormat);
          }

          if (badge) {
            const savingsCents = compareTotal - saleTotal;
            const savingsValue = Math.max(0, Math.floor(savingsCents / 100));
            badge.textContent = `Spare ${savingsValue}€`;
          }
        } else {
          const regularSpan = priceElement.querySelector(
            ".price__regular .price-item--regular",
          );
          if (!regularSpan) return;

          const regularTotal = basePrice + totals.price;
          regularSpan.innerHTML = this.formatMoney(regularTotal, moneyFormat);
        }
      }

      formatMoney(cents, format) {
        if (typeof cents == "string") {
          cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || this.money_format;

        function defaultOption(opt, def) {
          return typeof opt == "undefined" ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ",");
          decimal = defaultOption(decimal, ".");

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split("."),
            dollars = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands,
            ),
            cents = parts[1] ? decimal + parts[1] : "";

          return dollars + cents;
        }

        var match = formatString.match(placeholderRegex);

        if (match) {
          switch (match[1]) {
            case "amount":
              value = formatWithDelimiters(cents, 2);
              break;
            case "amount_no_decimals":
              value = formatWithDelimiters(cents, 0);
              break;
            case "amount_with_comma_separator":
              value = formatWithDelimiters(cents, 0, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              value = formatWithDelimiters(cents, 0, ".", ",");
              break;
          }
        }

        return formatString.replace(placeholderRegex, value);
      }

      parsePrice(value) {
        const parsed = parseInt(`${value}`.trim(), 10);
        return Number.isNaN(parsed) ? 0 : parsed;
      }

      parsePositiveInt(value, fallback = 1) {
        const parsed = parseInt(`${value ?? ""}`.trim(), 10);
        if (Number.isNaN(parsed) || parsed <= 0) {
          return fallback;
        }
        return parsed;
      }
    },
  );
}


document.querySelectorAll('.tab-nav-item').forEach(function(tab) {
  // shared activation logic scoped to the nearest tab container to support
  // duplicate desktop/mobile blocks with the same IDs
  function activateTab() {
    var container = tab.closest('.tab-box-desktop, .tab-box-mobile') || tab.closest('.tab-content') || document;
    var dataTab = tab.getAttribute('data-tab');

    // only toggle nav items inside this container
    container.querySelectorAll('.tab-nav-item').forEach(function(t) {
      t.classList.remove('active');
    });

    var currentPane = container.querySelector('.tab-pane.active');
    var targetPane = container.querySelector('#' + dataTab);

    // mark nav active
    tab.classList.add('active');

    // add small click animation on the tab element
    tab.classList.add('clicked');
    setTimeout(function() {
      tab.classList.remove('clicked');
    }, 220);

    // if same pane, do nothing
    if (currentPane === targetPane) {
      // still move indicator
      moveIndicatorToTab(tab);
      return;
    }

    // Simpler, robust approach: clear active/fade-in from all panes in this container
    // then activate the target and add fade-in. This avoids transitionend races
    // which can leave multiple panes active.
    var panes = Array.from(container.querySelectorAll('.tab-pane'));
    panes.forEach(function(p) {
      p.classList.remove('fade-in');
      p.classList.remove('active');
    });

    if (targetPane) {
      targetPane.classList.add('active');
      // force reflow before adding fade-in
      // eslint-disable-next-line no-unused-expressions
      targetPane.offsetWidth;
      targetPane.classList.add('fade-in');
    }

    // move the indicator now that the tab is active
    moveIndicatorToTab(tab);
  }

  // helper to move the sliding indicator for this tab-nav
  function moveIndicatorToTab(tabElement) {
    var nav = tabElement.closest('.tab-nav');
    if (!nav) return;
    var indicator = nav.querySelector('.tab-indicator');
    if (!indicator) return;
    var rect = tabElement.getBoundingClientRect();
    var navRect = nav.getBoundingClientRect();
    var left = rect.left - navRect.left + nav.scrollLeft;
    var width = rect.width;
    indicator.style.width = width + 'px';
    indicator.style.transform = 'translateX(' + left + 'px)';
  }

  // Prevent duplicate activation when touch events also trigger click
  tab.addEventListener('touchend', function(e) {
    // Prevent the subsequent click event on some browsers/phones
    e.preventDefault();
    tab.__touchHandled = true;
    activateTab();
  }, { passive: false });

  tab.addEventListener('click', function(e) {
    if (tab.__touchHandled) {
      // reset flag and ignore this synthetic click
      tab.__touchHandled = false;
      return;
    }
    activateTab();
  });

  // whenever a tab is activated via code, also move indicator
  tab.addEventListener('activated.custom', function() {
    moveIndicatorToTab(tab);
  });
});

// Initialize indicators for all tab-navs and set position on load/resize
function initTabIndicators() {
  document.querySelectorAll('.tab-nav').forEach(function(nav) {
    if (!nav.querySelector('.tab-indicator')) {
      var indicator = document.createElement('span');
      indicator.className = 'tab-indicator';
      nav.appendChild(indicator);
    }
    var activeTab = nav.querySelector('.tab-nav-item.active');
    if (activeTab) {
      var evt = new Event('activated.custom');
      activeTab.dispatchEvent(evt);
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initTabIndicators();
  // initial positioning for active panes
  document.querySelectorAll('.tab-pane.active').forEach(function(pane) {
    pane.offsetWidth; // reflow
    pane.classList.add('fade-in');
  });
});

window.addEventListener('resize', function() {
  // reposition indicators on resize
  document.querySelectorAll('.tab-nav-item.active').forEach(function(tab) {
    var evt = new Event('activated.custom');
    tab.dispatchEvent(evt);
  });
});

// Ensure any initially active panes are visible on load (add fade-in)
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.tab-pane.active').forEach(function(pane) {
    // force a reflow then add fade-in to trigger the transition
    // eslint-disable-next-line no-unused-expressions
    pane.offsetWidth;
    pane.classList.add('fade-in');
  });
});
